module.exports = __webpack_public_path__ + "media/img/corporate/plus-848e0803a27adea1f0ef958da824cb20.svg";